import { apiPost, apiGet } from './api';

/**
 * Perform login using email and password
 */
export async function login(email, password, is_demo = false) {
  return apiPost('/auth/login.php', { identifier: email, email, password, is_demo });
}

/**
 * Unified login endpoint supporting password and demo checkbox
 */
export async function loginUnified(payload) {
  return apiPost('/auth/login.php', payload);
}

/**
 * Send OTP for student verification (regular or demo)
 */
export async function sendOtpUnified(payload) {
  const normalizedPayload = {
    channel: payload.channel || (payload.email ? 'email' : 'email'),
    value: payload.value || payload.email || payload.identifier || '',
    email: payload.email || payload.identifier || '',
    identifier: payload.identifier || payload.email || '',
    is_demo: !!payload.is_demo
  };
  return apiPost('/auth/demo-login.php', normalizedPayload);
}

/**
 * Verify OTP code (regular or demo)
 */
export async function verifyOtpUnified(payload) {
  const normalizedPayload = {
    channel: payload.channel || (payload.email ? 'email' : 'email'),
    value: payload.value || payload.email || payload.identifier || '',
    email: payload.email || payload.identifier || '',
    identifier: payload.identifier || payload.email || '',
    otp: payload.otp || '',
    is_demo: !!payload.is_demo
  };
  return apiPost('/auth/demo-verify-otp.php', normalizedPayload);
}

/**
 * Set password for demo student post-OTP verification
 */
export async function setDemoPassword(payload) {
  return apiPost('/auth/set-demo-password.php', payload);
}

/**
 * Log out and clear active PHP session cookies
 */
export async function logout() {
  return apiPost('/auth/logout.php');
}

/**
 * Fetch authenticated session details for active user
 */
export async function getCurrentUser() {
  return apiGet('/auth/me.php');
}

/**
 * Trigger OTP email for password reset
 */
export async function forgotPassword(email) {
  return apiPost('/auth/forgot-password.php', { email });
}

/**
 * Verify OTP code entered by the user
 */
export async function verifyResetOtp(email, otp) {
  return apiPost('/auth/verify-reset-otp.php', { email, otp });
}

/**
 * Reset password with verified OTP
 */
export async function resetPassword(email, otp, newPassword, confirmPassword) {
  return apiPost('/auth/reset-password.php', { email, otp, newPassword, confirmPassword });
}
